var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("section", {
    style: {
      background: `url(${_vm.bannerUrl}) no-repeat center 0px`,
      backgroundSize: "cover"
    }
  }, [_c("Banner", {
    attrs: {
      imageUrl: _vm.bannerUrl,
      title: "智能质检",
      description: "智能质检系统利用机器质检替代人工质检的同时还对客服录音进行全面检测，并自动化生成质检报表和质检报告，质检报表和质检报告支持多维度自定义条件选择，可大幅提升工作效率，降低抽检不完备带来的隐患。"
    }
  })], 1), _c("div", {
    staticClass: "cooperation"
  }, [_c("div", {
    staticClass: "cooperation_main"
  }, [_c("p", {
    staticClass: "eTitle"
  }, [_vm._v("人机配合，高效质检")]), _c("div", {
    staticClass: "coopContent"
  }, [_c("img", {
    attrs: {
      src: require("@/assets/images/service/callqualityinspection/cooperation.webp"),
      alt: ""
    }
  }), _c("ul", _vm._l(_vm.cooperationList, function ({
    title,
    desc
  }, index) {
    return _c("li", {
      key: index,
      staticClass: "coopLi"
    }, [_c("h2", {
      staticClass: "coopTitle"
    }, [_vm._v(_vm._s(title))]), _c("p", {
      staticClass: "coopDesc"
    }, [_vm._v(_vm._s(desc))])]);
  }), 0)])])]), _c("div", {
    staticClass: "inspection"
  }, [_c("div", {
    staticClass: "inspection_main"
  }, [_c("p", {
    staticClass: "eTitle"
  }, [_vm._v("多维度质检内容")]), _c("FlowGrid", {
    style: {
      width: "100%",
      justifyContent: "space-between",
      marginTop: "65px"
    }
  }, _vm._l(_vm.chooes, function ({
    desc,
    title,
    icon
  }, idx) {
    return _c("div", {
      key: idx,
      staticClass: "cMain"
    }, [_c("img", {
      staticClass: "cImg",
      attrs: {
        src: icon,
        alt: ""
      }
    }), _c("h2", {
      staticClass: "eTitle2"
    }, [_vm._v(_vm._s(title))]), _c("p", {
      staticClass: "eDesc"
    }, [_vm._v(_vm._s(desc[0]))]), _c("p", {
      staticClass: "eDesc"
    }, [_vm._v(_vm._s(desc[1]))]), _c("p", {
      staticClass: "eDesc"
    }, [_vm._v(_vm._s(desc[2]))])]);
  }), 0)], 1)]), _c("div", {
    staticClass: "skill"
  }, [_c("SmartTitle", {
    attrs: {
      title: "强大功能，自如应对各种需求",
      desc: "POWERFUL, FREE TO RESPOND TO VARIOUS NEEDS"
    }
  }), _c("div", {
    staticClass: "skill_main"
  }, [_c("SmartCard", {
    attrs: {
      skills: _vm.skills
    }
  })], 1)], 1), _c("Cases", {
    attrs: {
      source: "aiProduct"
    }
  }), _c("Appointment2")], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };